<template>
  <div class="content" v-if="code">
    <div class="sub_title">
      <p>电话答疑<i></i></p>
    </div>
    <div class="dhua">
      <div class="left">
        <h3>010-64968381</h3>
        <p class="gs">中税网专家答疑热线为您提供财税服务</p>
        <p class="gs">工作日 9:00-12:00 13:00-17:00</p>
      </div>
      <img src="../../../assets/img/qa5.jpg" alt="">
    </div>
    <div class="sub_title">
      <p>答疑流程<i></i></p>
    </div>
    <ul class="liucheng">
      <li>
        <img src="../../../assets/img/qa3.png" alt="">
        <p>成功缴费加入会员</p>
      </li>
      <li class="jt"><img src="../../../assets/img/qa6.jpg" alt=""></li>
      <li>
        <img src="../../../assets/img/qa1.jpg" alt="">
        <p>把您需要进行的答疑电话发给你的专属学习顾问</p>
      </li>
      <li class="jt"><img src="../../../assets/img/qa6.jpg" alt=""></li>
      <li>
        <img src="../../../assets/img/qa2.jpg" alt="">
        <p>学习顾问把您发送的答疑电话录入答疑数据库</p>
      </li>
      <li class="jt"><img src="../../../assets/img/qa6.jpg" alt=""></li>
      <li>
        <img src="../../../assets/img/qa3.jpg" alt="">
        <p>数据库系统审核后24小时您就可以享受电话答疑服务</p>
      </li>
    </ul>
  </div>
  <div class="content" v-else>
    <div class="zwt">
      <br><br><br><br><br><br><br><br>
      <div class="zsw_img">
        <img src="../../../assets/statstics/监控未获取数据@2x.png" alt="">
      </div>
      <div class="zwt_wz">您暂时无法使用，请联系您的专属学习顾问确认已加入会员（金卡及以上会员）</div>
    </div>
  </div>
</template>
  
<script>
export default {
  props: ['code'],
  data() {
    return {

    }
  },
  methods: {


  }
}
</script>
  
<style scoped lang="less">
.zwt {
   width: 700px;
  height: 600px;
  text-align: center;
  margin: 0 auto;

  .zsw_img {
    width: 260px;
    height: 140px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;

  }

  .zwt_wz {
   width: 700px;
    margin-top: 70px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
  }
}

.content {
  padding: 15px;
  width: 100%;
}

.content_form {
  display: flex;
  justify-content: center;
  padding-top: 20px;
}

.sub_title {
  width: 100%;
  display: flex;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  cursor: pointer;
  color: #3E63EE;
}

.sub_title p {
  margin-left: 20px;
  position: relative;
}

.sub_title p i {
  position: absolute;
  top: 28px;
  left: 30px;
  content: 0px;
  width: 16px;
  border-top: 4px solid #3E63EE;
}

.dhua {
  display: flex;
}

.dhua .left {
  width: 560px;
  padding-top: 43px;
  padding-left: 140px;
}

.dhua .left h3 {
  font-size: 28px;
  font-weight: bold;
  color: #666666;
}

.dhua .left .gs {
  font-size: 18px;
  color: #666666;
}

.dhua img {
  width: 320px;
  height: 300px;
}

.liucheng {
  width: 65%;
  margin-top: 20px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  color: #a7a7a7;
}

.liucheng li {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.liucheng img {
  /* width: 64px; */
  height: 55px;
}

.liucheng .jt img {
  width: 44px;
  height: 16px;
}
</style>